import React from 'react'
import Select from 'react-select'

const SelectInput = ({
  className,
  disabled,
  isMulti,
  name,
  onChange,
  options,
  placeholder,
  required,
  value
}) => {
  const renderExtraClass = () => {
    return `${disabled && 'react-select--disabled'} ${value && 'react-select--filled'}`
  }

  return (
    <React.Fragment>
      <div className="relative">
        <div className={`${renderExtraClass()} relative z1`}>
          <Select
            classNamePrefix={className}
            isDisabled={disabled}
            isMulti={isMulti}
            name={name}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            value={value ? { label: value, value } : undefined}
          />
        </div>

        {/* Added this select here for validation to work */}
        <select
          className="absolute border-none col-12 height-100-p left-0 top-0"
          required={required}
          onChange={onChange}
          value={value}
        >
          <option value="">Select something</option>

          {
            options.map(item => (
              <option
                key={item.label}
                value={item.label}
              >
                {item.label}
              </option>
            ))
          }
        </select>
      </div>
    </React.Fragment>
  );
}

export default SelectInput;
